import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const NotificationModal = ({ 
    show, 
    type = 'success', 
    title, 
    message, 
    onClose, 
    autoClose = true, 
    duration = 1000 
}) => {
    useEffect(() => {
        if (show && autoClose) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [show, autoClose, duration, onClose]);

    if (!show) return null;

    const getTypeStyles = () => {
        switch (type) {
            case 'success':
                return {
                    gradient: 'from-green-400 to-green-600',
                    icon: (
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                        />
                    )
                };
            case 'error':
                return {
                    gradient: 'from-red-400 to-red-600',
                    icon: (
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    )
                };
            case 'warning':
                return {
                    gradient: 'from-yellow-400 to-yellow-600',
                    icon: (
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.728-.833-2.498 0L4.316 16.5c-.77.833.192 2.5 1.732 2.5z"
                        />
                    )
                };
            case 'info':
                return {
                    gradient: 'from-blue-400 to-blue-600',
                    icon: (
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    )
                };
            default:
                return {
                    gradient: 'from-green-400 to-green-600',
                    icon: (
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                        />
                    )
                };
        }
    };

    const { gradient, icon } = getTypeStyles();

    const modalContent = (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[9999]">
            <div className={`bg-gradient-to-r ${gradient} rounded-2xl p-10 text-white text-center shadow-2xl transform animate-pulse`}>
                <div className="flex justify-center mb-6">
                    <div className="bg-white/20 rounded-full p-4">
                        <svg
                            className="w-16 h-16 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            {icon}
                        </svg>
                    </div>
                </div>
                <h2 className="text-2xl font-bold mb-3">{title}</h2>
                <p className="text-lg opacity-90">{message}</p>
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
};

export default NotificationModal;
